import { useLoginWithMicrosoftMutation } from "../../features/auth/authApi";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router";
import { useEffect, useRef } from "react";

import MemoriqueIconGold from "../../assets/icons/MemoriqueIconGold";
import GlobalMapIllustration from "../../components/GlobalMapIllustration";
import LoginSocialAuth from "./LoginSocialAuth";

interface AccountLayoutProps {
  helpText?: string;
  isCombineForm?: boolean;
  hideSocialLogin?: boolean;
  title?: string;
  subtitle?: string;
  children?: React.ReactNode;
}

const LoginContainerLayout = ({
  helpText,
  hideSocialLogin,
  title,
  subtitle,
  children,
}: AccountLayoutProps) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [loginWithMicroft] = useLoginWithMicrosoftMutation();
  const hasMounted = useRef(false);

  useEffect(() => {
    if (!hasMounted.current) {
      const hash = window.location.search; // e.g. "#code=M.C551_BAY..."
      const params = new URLSearchParams(hash.substring(1)); // remove the leading "#"
      const code = params.get("code");

      if (code) {
        hasMounted.current = true;
        msLogin(code);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const msLogin = async (code: string) => {
    try {
      const redirectUri = `${import.meta.env.VITE_LOCAL_URL}${
        window.location.pathname.includes("profile") ? "/profile" : "/login"
      }`;
      const loginResponse = await loginWithMicroft({
        code: code,
        redirectUri,
      }).unwrap();

      if (loginResponse?.data?.accessToken) {
        localStorage.setItem("accessToken", loginResponse?.data?.accessToken);
        localStorage.setItem("refreshToken", loginResponse?.data?.refreshToken);
        navigate("/");
      } else {
        toast.error("Invalid response");
      }
    } catch (e: any) {
      console.log(e);
      navigate(pathname);
      toast.error(e?.data?.message ?? "login failed");
    }
  };

  return (
    <div className="account-pages" style={{ background: "#ffffff", width: "100%", height: "100vh", overflow: "hidden", position: "relative" }}>
      {/* Logo at top left */}
      <div className="top-logo-container">
        <MemoriqueIconGold />
      </div>
      
      <div className="main_wrapper_login">
          {/* Left Side - Marketing Content */}
          <div className="left_view_wrapper">
            <div className="marketing-content">
              <h1 className="marketing-title">
                Generate reviews, referrals, leads, and data through gifting
              </h1>
              <p className="marketing-description">
                Transform every gift into valuable business insights.
              </p>
              <div className="illustration-wrapper">
                <GlobalMapIllustration />
              </div>
            </div>
          </div>

          {/* Right Side - Form */}
          <div className="right_view_wrapper">
            <div className="login-form-container">
              <div className="login-header">
                <h2 className="welcome-title">{title ?? "Welcome back to Memorique"}</h2>
                <p className="welcome-subtitle">{subtitle ?? "Sign in to transform your gifting experience"}</p>
              </div>

              <div className="gradient-form-card">
                {!hideSocialLogin && <LoginSocialAuth helpText={helpText} />}

                {hideSocialLogin && helpText && (
                  <p className="small text-muted mb-3">{helpText}</p>
                )}

                {children}
              </div>
            </div>
          </div>
        </div>
    </div >
  );
};

export default LoginContainerLayout;
